/**
 * Tap binding shared by Page.tsx and Menu.tsx.
 *
 * Extracted from Page.tsx when the settings menu became its own file — it was defined inline there,
 * and a second copy in Menu.tsx would have been a second `armed` map, so a pointer armed on one
 * component could never be matched by the other.
 *
 * Pointer events rather than onClick: on a phone a click arrives ~300ms after the finger lifts and
 * after any scroll settles, which on a betting control reads as a dropped tap. Arming on
 * pointerdown and firing on pointerup over the SAME element is immediate and still cancels if the
 * finger slides off. Enter/Space are handled too, so the buttons stay keyboard-operable.
 */
const armed = new WeakMap<Element, number>();

export function press(fn: () => void) {
  return {
    onPointerDown: (e: React.PointerEvent) => { e.stopPropagation(); armed.set(e.currentTarget, e.pointerId); },
    onPointerUp: (e: React.PointerEvent) => { e.stopPropagation(); if (armed.get(e.currentTarget) !== e.pointerId) return; armed.delete(e.currentTarget); if ((e.currentTarget as HTMLButtonElement).disabled) return; fn(); },
    onPointerCancel: (e: React.PointerEvent) => { armed.delete(e.currentTarget); },
    onKeyDown: (e: React.KeyboardEvent) => { if (e.key !== 'Enter' && e.key !== ' ') return; if (e.repeat) return; e.preventDefault(); e.stopPropagation(); if ((e.currentTarget as HTMLButtonElement).disabled) return; fn(); },
  };
}
